// Club Settings: the club's own sign-up link, /join/<name>, with a switch for
// whether families can use it, the club policies they agree to, and a QR code
// to print or share.
import React, { useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { APP_URL } from '../utils/adminSite';

// Trampoline Life's link is on its own site; every other club's is on Run The
// Club's sign-in site. A local copy stays local.
const linkBase = (isHouseClub) =>
  (isHouseClub || /^(localhost|127\.0\.0\.1)$/.test(window.location.hostname) ? window.location.origin : APP_URL);

export default function SignupLinkSettings({ club, settings, onChange }) {
  const [copied, setCopied] = useState(false);
  const url = club.emailName ? `${linkBase(club.isHouseClub)}/join/${club.emailName}` : null;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };

  return (
    <div className="form-group">
      <label className="form-label">Sign-up link</label>
      {!url ? (
        <p className="text-muted">The club doesn't have a link name yet. Ask Run The Club to set one.</p>
      ) : (
        <>
          <div>
            <label>
              <input type="checkbox" checked={!!settings.signupsOpen} onChange={e => onChange('signupsOpen', e.target.checked)} />
              {' '}Families can sign up at the club's link
            </label>
          </div>
          <div className="signup-link">
            <QRCodeSVG value={url} size={112} marginSize={1} className="signup-link__qr" />
            <div className="signup-link__text">
              <a href={url} target="_blank" rel="noopener noreferrer">{url}</a>
              <div>
                <button type="button" className="btn btn-sm btn-outline" style={{ width: 'auto', display: 'inline-block' }} onClick={copy}>
                  {copied ? 'Copied' : 'Copy link'}
                </button>
              </div>
              <small className="text-muted">
                Share it with families, or print the QR code for the noticeboard. Anyone who signs up there joins this club
                {settings.signupsOpen ? '.' : ' once the box above is ticked and saved.'}
              </small>
            </div>
          </div>
        </>
      )}
      <label htmlFor="policies-url" className="form-label" style={{ fontWeight: 400, marginTop: '0.75rem' }}>
        Club policies families agree to when they sign up
      </label>
      <input
        id="policies-url"
        type="url"
        className="form-control"
        placeholder="https://"
        value={settings.policiesUrl ?? ''}
        onChange={e => onChange('policiesUrl', e.target.value)}
      />
      <small className="text-muted">A link to the club's policies. Leave blank if there's nothing to agree to.</small>
    </div>
  );
}
